import React from 'react';
import SarasPaging from '../../library/input/paging/SarasPaging2';

const DocPaging = (props) => {
    const { onPageChange, paging, goTop, hidePageIfNR } = props;

    return (
        <div className="uiSearchPaging" >
            <SarasPaging onPageChange={onPageChange} paging={paging} goTop={goTop} hidePageIfNR={hidePageIfNR} />
        </div>
    )
}

export default DocPaging